var exports = {
  "uW": "xa15a2ab7--419236--section",
  "r7": "xa15a2ab7--419236--shadow",
  "we": "xa15a2ab7--419236--overflowed",
  "sJ": "xa15a2ab7--419236--borders",
  "qj": "xa15a2ab7--419236--spaces",
  "ZO": "xa15a2ab7--419236--hide-for-print",
};

module.exports = exports;
